import { render, staticRenderFns } from "./ItemShopguide.vue?vue&type=template&id=64ca7c85"
import script from "./ItemShopguide.vue?vue&type=script&lang=js"
export * from "./ItemShopguide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports